import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './Countdown.scss';

interface IOwnProps {
  label: string;
  value: number;
  fill: number;
  currency: string;
}

const Countdown: React.SFC<IOwnProps> = ({ fill, value, label, currency }) => {
  const progressCircleClassNames = cx({
    [Styles.progressCircle]: true,
    [Styles[`p${Math.round(fill)}`]]: true,
    [Styles.over50] : fill > 50
  });

  return (
    <div className={Styles.wrapper}>
      <div className={progressCircleClassNames}>
        <div className={Styles.leftHalfClipper}>
          <div className={Styles.first50Bar}/>
          <div className={Styles.valueBar}/>
        </div>
      </div>
      <div className={Styles.description}>{value && fill && fill < 100 ? value.toFixed(0) : ''}{currency} {label}</div>
    </div>
  );
};

export default Countdown;
